/* global getCookie */

if (!customElements.get("cart-drawer-discounts")) {
    function getCookie(name) {
      const cookieString = `; ${document.cookie}`;
      const cookies = cookieString.split(`; ${name}=`);
  
      if (cookies.length === 2) {
        return decodeURIComponent(cookies.pop().split(";").shift());
      }
  
      return null;
    }
  
    class CartDrawerDiscounts extends HTMLElement {
      constructor() {
        super();
        this.discountListContainerEl = document.querySelector(
          "#discountListContainer"
        );
        this.discountFormEl = this.querySelector("form.discount-form");
        this.submitButton = this.querySelector("#discountSubmit");
        this.discountInputEl = this.querySelector("input.discount-input");
        this.discountErrorEl = this.querySelector(".discount-error");
        this.isProcessing = false;
        this.init();
      }
  
      init() {
        console.log('🔧 Inicializando CartDrawerDiscounts...');
        
        // Apply discount if it exists in local storage
        if (localStorage.discountCode) {
          try {
            const code = JSON.parse(localStorage.discountCode).code;
            this.applyDiscount({ code, isInit: true });
          } catch (error) {
            console.error('Error al cargar descuento del localStorage:', error);
            localStorage.removeItem("discountCode");
          }
        } else {
          const discountCookie = getCookie("discount_code");
  
          if (discountCookie && discountCookie != "CLEAR") {
            this.applyDiscount({ code: discountCookie, isInit: false });
          }
        }
  
        if (this.discountFormEl) {
          this.discountFormEl.addEventListener("submit", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            const discountCode = this.discountInputEl.value.trim();
            if (discountCode.length < 1) return;
            
            console.log('📝 Aplicando descuento desde formulario:', discountCode);
            this.applyDiscount({ code: discountCode, isInit: false });
          });
        }
  
        if (this.submitButton) {
          this.submitButton.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            const discountCode = this.discountInputEl.value.trim();
  
            if (discountCode.length < 1) return;
  
            console.log('📝 Aplicando descuento desde botón:', discountCode);
            this.applyDiscount({ code: discountCode, isInit: false });
          });
        }
  
        // Reinicializar event listeners para botones de eliminar descuento
        this.setupRemoveDiscountListeners();
      }
  
      setupRemoveDiscountListeners() {
        document
          .querySelectorAll(".js-remove-discount")
          .forEach((el) => {
            // Remover listeners existentes para evitar duplicados
            el.removeEventListener("click", this.clearDiscount.bind(this));
            // Agregar nuevo listener
            el.addEventListener("click", this.clearDiscount.bind(this));
          });
      }
  
      clearDiscount() {
        console.log('🗑️ Limpiando descuento...');
        
        this.discountListContainerEl?.classList.add("hidden");
        document.querySelector('.subtotal-wrapper')?.classList.add("hidden");
  
        setTimeout(() => {
          this.updateCartPrice();
        }, 500);
  
        this.clearLocalStorage();
        window.appliedDiscounts = null;
        
        // Limpiar descuento en Shopify
        fetch("/checkout?discount=%20").catch(error => {
          console.error('Error al limpiar descuento en checkout:', error);
        });
        fetch("/discount/CLEAR").catch(error => {
          console.error('Error al limpiar descuento:', error);
        });

        // Dispatch event for discount removal
        document.dispatchEvent(new CustomEvent('discount:removed', {
          bubbles: true,
          detail: { timestamp: Date.now() }
        }));
      }
  
      clearLocalStorage() {
        localStorage.removeItem("discountCode");
      }
  
      createDiscountElements(discountApplications) {
        console.log('🎨 Creando elementos de descuento:', discountApplications);
        
        const discountListContainerEl = document.querySelector(
          "#discountListContainer"
        );
        this.discountListContainerEl = discountListContainerEl;
  
        if (!discountListContainerEl) {
          console.error('❌ No se encontró discountListContainerEl');
          return;
        }
        
        const discountListEl = discountListContainerEl.querySelector("ul");
        if (!discountListEl) {
          console.error('❌ No se encontró discountListEl');
          return;
        }
        
        const discountEl = discountListEl.querySelector("li");
        if (!discountEl) {
          console.error('❌ No se encontró discountEl');
          return;
        }
        
        discountListEl.innerHTML = "";
  
        discountApplications.forEach((discount) => {
            const removeDiscountButton =
            `<div class="discount-box">
                <button class="button-remove js-remove-discount"><svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M5 19 19 5M5 5l14 14"></path></svg></button>
            </div>`;
            const discountString = `<span class="discount-name">${discount.title}</span> ${removeDiscountButton} <span class="discount-value">-${discount.amount} ${Shopify.currency.active}</span>`
            const element = discountEl.cloneNode(true)
  
          element.innerHTML = element.innerHTML.replace(
            "[PLACEHOLDER]",
            discountString
          );
  
          discountListEl.appendChild(element);
        });
  
        discountListContainerEl.classList.remove("hidden");
  
        // Configurar event listeners para los nuevos botones
        this.setupRemoveDiscountListeners();
      }
  
      updateCartPrice() {
        console.log('💰 Actualizando precio del carrito...');
        
        // Use the new function that only updates prices without affecting recommendations
        this.updatePriceDisplayOnly();
      }
  
      /**
       * Update only the price display without affecting recommendations
       */
      async updatePriceDisplayOnly() {
        try {
          const response = await fetch('/cart.js');
          const cartData = await response.json();
          
          // Instead of manually updating DOM elements, trigger a cart refresh
          // This will update all prices including the checkout button without losing text
          const drawer = document.querySelector("cart-drawer");
          if (drawer) {
            // Dispatch a custom event to trigger cart refresh
            document.dispatchEvent(new CustomEvent('cart-price:update', {
              bubbles: true,
              detail: { 
                cartData: cartData,
                timestamp: Date.now() 
              }
            }));
            
            // Also trigger a cart items refresh to update all prices
            const cartItems = drawer.querySelector('cart-items');
            if (cartItems && typeof cartItems.refresh === 'function') {
              // Pass false to avoid refreshing recommendations
              cartItems.refresh(false);
            }
          }
          
          console.log('✅ Carrito actualizado para reflejar nuevos precios');
        } catch (error) {
          console.error('❌ Error al actualizar precios:', error);
        }
      }
  
      async fetchCart() {
        try {
          console.log('🛒 Obteniendo carrito...');
          const response = await fetch("/cart.js");
          
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          
          const data = await response.json();
          console.log('✅ Carrito obtenido:', data);
          return data;
        } catch (error) {
          console.error('❌ Error al obtener carrito:', error);
          throw error;
        }
      }
  
      async applyDiscount({ code, isInit }) {
        if (this.isProcessing) {
          console.log('⏳ Ya hay una operación de descuento en proceso...');
          return;
        }
        
        this.isProcessing = true;
        console.log('🚀 Aplicando descuento:', { code, isInit });
        
        try {
          // Limpiar error anterior
          if (this.discountErrorEl) {
            this.discountErrorEl.classList.add("hidden");
          }
          
          // Obtener el carrito actual para verificar que no esté vacío
          const cartData = await this.fetchCart();
          
          if (cartData.item_count === 0) {
            throw new Error('El carrito está vacío. Agrega productos antes de aplicar un descuento.');
          }
          
          // Crear el body para la verificación (simplificado)
          const body = {
            checkout: {
              discount_code: code,
              line_items: cartData.items,
            },
          };
          
          // Aplicar el descuento usando la API estándar de Shopify
          const discountUrl = `/discount/${code}`;
          console.log('🔗 Aplicando descuento en:', discountUrl);
          
          const response = await fetch(discountUrl, {
            method: 'GET',
            credentials: 'include',
          });
          
          if (!response.ok) {
            if (response.status === 404) {
              throw new Error('Código de descuento no válido o no encontrado');
            }
            throw new Error(`Error al aplicar descuento: ${response.status}`);
          }
          
          // Obtener el carrito actualizado para verificar si el descuento se aplicó
          const updatedCartData = await this.fetchCart();
          
          if (updatedCartData.cart_level_discount_applications.length > 0) {
            console.log('✅ Descuento aplicado correctamente');
            
            const appliedDiscounts = updatedCartData.cart_level_discount_applications.map(discount => ({
              title: discount.title,
              amount: (discount.total_allocated_amount / 100).toFixed(2),
              type: discount.type
            }));
            
            window.appliedDiscounts = appliedDiscounts;
  
            const lineItemPrice = updatedCartData.total_price / 100;
  
            const localStorageValue = {
              code: code.trim(),
              totalCart: lineItemPrice,
            };
            localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
  
            if (!isInit) {
              setTimeout(() => {
                this.createDiscountElements(appliedDiscounts);
                this.discountListContainerEl.classList.remove("hidden");
              }, 1000);
            } else {
              this.createDiscountElements(appliedDiscounts);
              this.discountListContainerEl.classList.remove("hidden");
            }
  
            if (this.discountErrorEl) {
              this.discountErrorEl.classList.add("hidden");
            }
            
            try {
              this.closest("cart-drawer-disclosure")?.close();
            } catch (error) {
              // No importa si no está dentro de un cart-drawer-disclosure
            }

            // Single price update instead of multiple
            if (!isInit) {
              this.updateCartPrice();
            }

            // Dispatch event for successful discount application
            document.dispatchEvent(new CustomEvent('discount:applied', {
              bubbles: true,
              detail: { 
                code: code,
                discounts: appliedDiscounts,
                timestamp: Date.now() 
              }
            }));
          } else {
            console.log('❌ Descuento no aplicado - código inválido');
            this.clearDiscount();
  
            if (this.discountErrorEl) {
              this.discountErrorEl.classList.remove("hidden");
              this.discountErrorEl.innerHTML = "Código de descuento no válido. Verifica el código e inténtalo de nuevo.";
            }
          }
        } catch (error) {
          console.error('❌ Error al aplicar descuento:', error);
          
          if (this.discountErrorEl) {
            this.discountErrorEl.classList.remove("hidden");
            this.discountErrorEl.innerHTML = error.message || "Error al aplicar el descuento. Inténtalo de nuevo.";
          }
        } finally {
          this.isProcessing = false;
          
          // Limpiar input
          if (this.discountInputEl) {
            this.discountInputEl.value = "";
          }
        }
      }
    }
  
    customElements.define("cart-drawer-discounts", CartDrawerDiscounts);
  }